import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { services } from '../data/services';

function SiteNavbar() {
  const location = useLocation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const navbarRef = useRef<HTMLElement | null>(null);
  const servicePaths = services.map((service) => service.path);
  const isServicesActive =
    location.pathname === '/services' || servicePaths.includes(location.pathname);
  const closeMobileNav = () => setMobileNavOpen(false);

  useEffect(() => {
    closeMobileNav();
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileNavOpen) {
      return;
    }

    const handleOutsideClick = (event: MouseEvent | TouchEvent) => {
      if (!navbarRef.current) {
        return;
      }

      const target = event.target as Node | null;
      if (target && !navbarRef.current.contains(target)) {
        closeMobileNav();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, [mobileNavOpen]);

  return (
    <nav ref={navbarRef} className="site-navbar navbar navbar-expand-lg sticky-top shadow-sm">
      <div className="container">
        <Link
          className="navbar-brand d-flex align-items-center"
          to="/physiotherapy-bradford"
          onClick={closeMobileNav}
        >
          <img
            src="/logo.png"
            alt="YH Physio and Performance"
            className="navbar-brand-logo"
            decoding="async"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setMobileNavOpen((isOpen) => !isOpen)}
          aria-controls="mainNav"
          aria-expanded={mobileNavOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className={`collapse navbar-collapse${mobileNavOpen ? ' show' : ''}`} id="mainNav">
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item">
              <NavLink to="/physiotherapy-bradford" end className="nav-link" onClick={closeMobileNav}>
                Home
              </NavLink>
            </li>
            <li className="nav-item dropdown">
              <a
                className={`nav-link dropdown-toggle${isServicesActive ? ' active' : ''}`}
                href="/services"
                id="servicesDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Services
              </a>
              <ul className="dropdown-menu" aria-labelledby="servicesDropdown">
                {services.map((service) => (
                  <li key={service.slug}>
                    <NavLink className="dropdown-item" to={service.path} onClick={closeMobileNav}>
                      {service.navName}
                    </NavLink>
                  </li>
                ))}
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <NavLink className="dropdown-item" to="/how-it-works#faqs" onClick={closeMobileNav}>
                    FAQs
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <NavLink to="/conditions" className="nav-link" onClick={closeMobileNav}>
                Conditions
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/testimonials" className="nav-link" onClick={closeMobileNav}>
                Testimonials
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/how-it-works" className="nav-link" onClick={closeMobileNav}>
                How It Works
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about-us" className="nav-link" onClick={closeMobileNav}>
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact-us" className="nav-link" onClick={closeMobileNav}>
                Contact Us
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default SiteNavbar;
